<template>
    <div>
        <div v-if="loader == 'LOADING'">
            <div v-for="(item, i) in 4" :key="i">
                <categoriesPlaceholder></categoriesPlaceholder>
            </div>
        </div>
        <div class="grid-view" v-else-if="loader == 'FOUND'">
            <noorPlayGrid
                :contents="screenContent"
                :section="screen"
                :message="''"
                :isScrollable="true"
                :playerInstance="playerInstance"
                :isMetaRedirection = true
                @loadMore="loadMoreContents()"
            ></noorPlayGrid>
        </div>
        <div v-else>
            <p class="not-found-list">{{$t('No Such Contents Found')}}</p>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from "vuex";
    import { store } from "@/store/store";
    export default {
        data () {
            return  {
                loader: 'LOADING',
                screenContent: [],
                screen: {},
                matchCategory: [
                                {'category' : 'hindi-movies', 'objtype':'content'},
                                {'category' : 'hindi-shows', 'objtype':'series'},
                                {'category' : 'content', 'objtype':'content'},
                                {'category' : 'hindi-video-songs', 'objtype':'content'},
                                {'category' : 'hindi-short-video-bytes', 'objtype':'content'},
                                {'category' : 'hindi-kids', 'objtype':'content'},
                                {'category' : 'hindi-devotional-videos', 'objtype':'content'},
                                ],
                objectType: null,
                currentPage : 1,
                totalcount: null,
                // Genre-specific SEO meta data for client-side updates
                genreSeoData: {
                    // Movie genres
                    "hindi-movies/genre/action": {
                        "title": "Hindi Action Films | Stream Action Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Action Movies online on Ultra Play OTT, packed with thrilling stunts, high-energy adventures, and blockbuster entertainment."
                    },
                    "hindi-movies/genre/adventure": {
                        "title": "Hindi Adventure Films | Stream Adventure Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Adventure Movies online on Ultra Play OTT, featuring exciting journeys, daring quests, and unforgettable experiences."
                    },
                    "hindi-movies/genre/animation": {
                        "title": "Hindi Animation Films | Stream Animation Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Animation Movies online on Ultra Play OTT, filled with colorful characters, imaginative stories, and family entertainment."
                    },
                    "hindi-movies/genre/biography": {
                        "title": "Hindi Biography Films | Stream Biography Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Biography Movies online on Ultra Play OTT, showcasing inspiring life stories, achievements, and remarkable journeys."
                    },
                    "hindi-movies/genre/comedy": {
                        "title": "Hindi Comedy Films | Stream Comedy Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Comedy Movies online on Ultra Play OTT, featuring hilarious moments, witty storytelling, and endless laughter."
                    },
                    "hindi-movies/genre/crime": {
                        "title": "Hindi Crime Films | Stream Crime Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Crime Movies online on Ultra Play OTT, packed with gripping investigations, criminal masterminds, and unexpected twists."
                    },
                    "hindi-movies/genre/devotional": {
                        "title": "Hindi Devotional Films | Stream Devotional Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Devotional Movies online on Ultra Play OTT, featuring spiritual teachings, faith-based stories, and divine inspiration."
                    },
                    "hindi-movies/genre/drama": {
                        "title": "Hindi Drama Films | Stream Drama Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Drama Movies online on Ultra Play OTT, showcasing powerful emotions, compelling characters, and engaging storytelling."
                    },
                    "hindi-movies/genre/fantasy": {
                        "title": "Hindi Fantasy Films | Stream Fantasy Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Fantasy Movies online on Ultra Play OTT, featuring magical worlds, extraordinary adventures, and epic tales."
                    },
                    "hindi-movies/genre/horror": {
                        "title": "Hindi Horror Films | Stream Horror Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Horror Movies online on Ultra Play OTT, packed with chilling suspense, terrifying moments, and spine-tingling thrills."
                    },
                    "hindi-movies/genre/mystery": {
                        "title": "Hindi Mystery Films | Stream Mystery Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Mystery Movies online on Ultra Play OTT, filled with intriguing puzzles, hidden secrets, and unexpected revelations."
                    },
                    "hindi-movies/genre/romance": {
                        "title": "Hindi Romance Films | Stream Romance Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Romance Movies online on Ultra Play OTT, featuring heartfelt relationships, emotional journeys, and timeless love stories."
                    },
                    "hindi-movies/genre/romantic": {
                        "title": "Hindi Romantic Films | Stream Romantic Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Romantic Movies online on Ultra Play OTT, filled with charming moments, touching emotions, and unforgettable love stories."
                    },
                    "hindi-movies/genre/sports": {
                        "title": "Hindi Sports Films | Stream Sports Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Sports Movies online on Ultra Play OTT, featuring inspiring athletes, thrilling competitions, and unforgettable victories."
                    },
                    "hindi-movies/genre/social": {
                        "title": "Hindi Social Films | Stream Social Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Social Movies online on Ultra Play OTT, exploring meaningful themes, societal issues, and thought-provoking narratives."
                    },
                    "hindi-movies/genre/thriller": {
                        "title": "Hindi Thriller Films | Stream Thriller Movies on Ultra Play OTT",
                        "description": "Stream the best Hindi Thriller Movies online on Ultra Play OTT, packed with suspenseful plots, unexpected twists, and intense entertainment."
                    },
                    // Series genres
                    "hindi-shows/genre/action": {
                        "title": "Stream Hindi Action Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Action Web Series, TV Shows, Serials online on Ultra Play OTT, packed with thrilling action, daring missions, and nonstop entertainment."
                    },
                    "hindi-shows/genre/comedy": {
                        "title": "Stream Hindi Comedy Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Comedy Web Series, TV Shows, Serials online on Ultra Play OTT, filled with hilarious moments, witty humor, and endless laughter."
                    },
                    "hindi-shows/genre/crime": {
                        "title": "Stream Hindi Crime Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Crime Web Series, TV Shows, Serials online on Ultra Play OTT, featuring gripping investigations, criminal masterminds, and intense drama."
                    },
                    "hindi-shows/genre/devotional": {
                        "title": "Stream Hindi Devotional Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Devotional Web Series, TV Shows, Serials online on Ultra Play OTT, featuring spiritual stories, faith-based journeys, and divine inspiration."
                    },
                    "hindi-shows/genre/drama": {
                        "title": "Stream Hindi Drama Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Drama Web Series, TV Shows, Serials online on Ultra Play OTT, showcasing powerful emotions, compelling characters, and engaging storytelling."
                    },
                    "hindi-shows/genre/horror": {
                        "title": "Stream Hindi Horror Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Horror Web Series, TV Shows, Serials online on Ultra Play OTT, packed with chilling suspense, terrifying moments, and spine-tingling thrills."
                    },
                    "hindi-shows/genre/mystery": {
                        "title": "Stream Hindi Mystery Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Mystery Web Series, TV Shows, Serials online on Ultra Play OTT, filled with intriguing puzzles, hidden secrets, and unexpected revelations."
                    },
                    "hindi-shows/genre/romantic": {
                        "title": "Stream Hindi Romantic Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Romantic Web Series, TV Shows, Serials online on Ultra Play OTT, featuring heartfelt relationships, emotional journeys, and unforgettable love stories."
                    },
                    "hindi-shows/genre/social": {
                        "title": "Stream Hindi Social Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Social Web Series, TV Shows, Serials online on Ultra Play OTT, exploring meaningful themes, societal issues, and thought-provoking narratives."
                    },
                    "hindi-shows/genre/thriller": {
                        "title": "Stream Hindi Triller Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Thriller Web Series, TV Shows, Serials online on Ultra Play OTT, packed with suspenseful plots, unexpected twists, and edge-of-your-seat entertainment."
                    },
                    "hindi-shows/genre/mythological": {
                        "title": "Stream Hindi Mythological Web Series, TV Shows, Serials on Ultra Play OTT",
                        "description": "Stream the best Hindi Mythological Web Series, TV Shows, Serials online on Ultra Play OTT, featuring legendary tales, divine characters, and timeless traditions."
                    }
                }
            }
        },
        props: {
            playerInstance: {
                type: Object,
            }
        },
        watch: {
            // Update meta tags when navigating between genre pages via SPA
            $route() {
                this.updateGenreMeta();
            }
        },
        methods: {
            updateGenreMeta() {
                const params = this.$router.currentRoute.params;
                const objecttype = params.objecttype || '';
                const type = params.type || '';
                const value = params.value || '';

                // Build the lookup key, e.g. "hindi-movies/genre/action"
                const lookupKey = `${objecttype}/${type}/${value}`.toLowerCase();
                const seoData = this.genreSeoData[lookupKey];

                if (seoData) {
                    // Update document title
                    document.title = seoData.title;

                    // Update meta description
                    const metaDesc = document.querySelector('meta[name="description"]');
                    if (metaDesc) metaDesc.setAttribute('content', seoData.description);

                    // Update og:title
                    const ogTitle = document.querySelector('meta[property="og:title"]');
                    if (ogTitle) ogTitle.setAttribute('content', seoData.title);

                    // Update twitter:title
                    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
                    if (twitterTitle) twitterTitle.setAttribute('content', seoData.title);

                    // Update og:description
                    const ogDesc = document.querySelector('meta[property="og:description"]');
                    if (ogDesc) ogDesc.setAttribute('content', seoData.description);

                    // Update twitter:description
                    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
                    if (twitterDesc) twitterDesc.setAttribute('content', seoData.description);
                }
            },
            loadMoreContents () {
                if (this.totalcount && this.totalcount == this.screenContent.length) {
                    return;
                }
                this.currentPage = this.currentPage + 1;
                this.getPaginationContent();
            },
            getPaginationContent () {
                this.screen = {
                displayType: "PORTRAIT"
                }
      
            console.log("this.$router.currentRoute.params", this.$router.currentRoute.params)
            this.matchCategory.filter((item, i) => {
                if(item.category === this.$router.currentRoute.params.objecttype) {
                    this.objectType = item;
                }
            });
            let customParams = {
                objecttype: this.objectType ? this.objectType.objtype : this.$router.currentRoute.params.objecttype
            }
            customParams[this.$router.currentRoute.params.type] = this.$router.currentRoute.params.value;

           let  payload =  {
                endpoint: 'subscriber/v1/content',
                params: customParams,
            }
            let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
            localDisplayLang = localDisplayLang == 'hi' ? 'hin' : localDisplayLang;
            payload.params.displaylanguage = localDisplayLang;
             payload.params.page = this.currentPage;

  
                store
                .dispatch("contentListMetaCall", payload)
                .then((response) => {
                    if (response.data && response.data.errorcode) {
                        this.loader = "NOTFOUND"
                    } else {
                        this.loader = 'FOUND';
                        if (response.data.data.length == 0) return;
                        this.totalcount = response.data.totalcount;
                        this.screenContent = [ ...this.screenContent, ...response.data.data]
                    }
                })
                .catch((err) => console.log(err));
            }
        },
        components: {
            categoriesPlaceholder: () =>
      import(/* webpackChunkName: "categoriesPlaceholder" */ "@/components/placeholders/categoriesPlaceholder.vue"),
    noorPlayGrid: () =>
      import(/* webpackChunkName: "categoriesPlaceholder" */ "@/components/Templates/noorPlayGrid.vue"),
        },
        computed: {
            ...mapGetters(["appConfig"]),
            },
        mounted () {
                this.updateGenreMeta();
                this.getPaginationContent()
            }
        }

</script>

<style lang="scss" scoped>
    .grid-view {
        margin: 0 auto;
        width: 100vw;
        height: 100%;
    }
    .not-found-list {
        text-align: center;
        color: #fff;
        padding: 10vh;
    }
</style>

